<template>
	<div v-if="loadFlag" class="load">
    <van-loading type="spinner"></van-loading>
    <div style="padding-top: 10px">加载中...</div>
	</div>
</template>
<script>
	export default {
		props: {
			loadFlag: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {

			}
		},
		mounted() {},
		methods: {

		}
	}
</script>
<style lang="less" scoped>

.load {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%,-50%);
  font-size: 15px;
  text-align: center;
  color: #666;
	z-index: 30;
}
</style>
